import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalEventsManagerService {
    private _loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public loggedInEmitter: Observable<boolean> = this._loggedIn.asObservable();

    constructor() { }

    loggedIn(ifShow: boolean) {
        this._loggedIn.next(ifShow);
    }
}
